import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env'
import { ProductSFResponse } from '@models'
import { firstValueFrom } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ProductSFService {
  constructor(private http: HttpClient) {}

  async getAll(text: string): Promise<ProductSFResponse[]> {
    const url = `${environment.api.baseUrl}/products/v1/models?text=${text}`
    const response = await firstValueFrom(this.http.get<ProductSFResponse[]>(url))
    return response
  }
}
